/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export default function getTextFieldHelperProps({
  required,
  disabled,
  errorHelperText
}: {
  required?: boolean;
  disabled?: boolean;
  errorHelperText: string;
  isNativeUser: boolean;
}) {
  const helperText = errorHelperText;

  return {
    required: required && !disabled,
    disabled,
    error: Boolean(errorHelperText),
    helperText: disabled ? '' : helperText
  };
}
